// extracted by mini-css-extract-plugin
export default {"container":"SearchDropDown_container__BNzXa","isVisible":"SearchDropDown_isVisible__xg55y"};